import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from 'recharts';

const COLORS = ['#1976d2', '#4caf50', '#ff9800', '#f44336'];

export const WorkOrdersChart = ({ data }) => {
  const defaultData = [
    { month: 'Jan', workOrders: 45 },
    { month: 'Feb', workOrders: 52 },
    { month: 'Mar', workOrders: 48 },
    { month: 'Apr', workOrders: 61 },
    { month: 'May', workOrders: 55 },
    { month: 'Jun', workOrders: 67 },
  ];

  const chartData = data?.length > 0 ? data : defaultData;

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Work Orders Trend
        </Typography>
        <Box sx={{ height: 300 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="workOrders"
                stroke="#1976d2"
                strokeWidth={2}
                dot={{ fill: '#1976d2', r: 4 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
};

export const WorkOrdersPieChart = ({ data }) => {
  const pieData = [
    { name: 'Completed', value: data?.workOrders?.completed || 45 },
    { name: 'In Progress', value: data?.workOrders?.inProgress || 23 },
    { name: 'Pending', value: data?.workOrders?.pending || 12 },
  ];

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Work Orders Status
        </Typography>
        <Box sx={{ height: 300 }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
};